// extracted by mini-css-extract-plugin
export default {"sign":"sign_sign__aRKfP","centerBox":"sign_centerBox__QoaoP","form":"sign_form__i56ej","input":"sign_input__ge0GA","errorMsg":"sign_errorMsg__v7r3P","button":"sign_button__Ft7uM"};